import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AccountService } from '../../users/data/services/account.service'; 
import { Router } from '@angular/router';
import { Station } from '../../users/data/types/station';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TokenStorageService } from 'src/app/core/service/token-storage.service';
import Swal from 'sweetalert2';
import { Subscription } from 'rxjs';
import { LevelNameService } from 'src/app/authentication/otp/level-name.service';
import { TableColumn } from 'src/app/shared/components/table/table.component';
@Component({
  selector: 'app-outstation-details',
  templateUrl: './outstation-details.component.html',
  styleUrls: ['./outstation-details.component.sass']
})
export class OutstationDetailsComponent implements OnInit {
  tableColumns: TableColumn[] = [];
  stationData: Station[] = []; 
  stations: Station[] = [];
  filteredStations: Station[] = [];
  isLoading = false;
  subscription!: Subscription; 
  errorMessage = '';
  parishId: any;
  parentLevelLabel: string = '';
  childLevelLabel: string = '';
  grandchildLevelName: string = '';

  constructor(
    private accountService: AccountService, 
    public dialog: MatDialog,
     private router: Router,
     private snackbar: MatSnackBar ,
     private levelNameService: LevelNameService,
     private tokenStorage: TokenStorageService
    ) { }

  ngOnInit(): void {
    const levelNames = this.levelNameService.getLevelNames();
    if (levelNames) {
      this.parentLevelLabel = levelNames.parentLevelName || 'Parent';
      this.childLevelLabel = levelNames.childLevelName || 'Child';
      this.grandchildLevelName = levelNames.grandchildLevelName || 'GrandChild';
    }
    this.loadStationData();
    this.loadStations();
  }

  initializeTableColumns(): void {
    this.tableColumns = [
      { 
        field: 'name', 
        header: this.childLevelLabel, 
        sortable: true,
        filterable: true,
        filterOptions: [],
        filterPlaceholder: `Select ${this.childLevelLabel}`
      },
      { field: 'location', header: 'Location', sortable: true },
      { field: 'members', header: 'Members', sortable: true },
      { field: 'communities', header: this.grandchildLevelName, sortable: true },
      { field: 'families', header: 'Families', sortable: true }
    ];
  }

  loadStationData() {
    this.isLoading = true;
    this.parishId = this.tokenStorage.getUser().parishId
    this.accountService.getStations(this.parishId).subscribe(
      (res: Station[]) => {
        this.stationData = res;
        this.isLoading = false;
      },
      (err) => {
        console.log(err);
        this.isLoading = false;
      }
    );
  }

  loadStations() {
    this.isLoading = true;
    this.parishId = this.tokenStorage.getUser().parishId;
    this.accountService.getAllOutStation(this.parishId).subscribe(
      (res: Station[]) => {
        this.stations = res;
        this.filteredStations = res;
        this.initializeTableColumns();
        this.tableColumns[0].filterOptions = res.map(s => s.name || '').filter(n => n);
        this.isLoading = false;
      },
      (err) => {
        console.log(err);
        this.isLoading = false;
      }
    );
  }

  onFilterChange(filteredData: Station[]): void {
    this.filteredStations = filteredData;
  }

  refresh() {
    this.loadStationData();
    this.loadStations();
  }

  downloadPDF(): void {
    if (this.filteredStations.length === 0 || this.filteredStations.length === this.stations.length) {
      this.showSnackbar('Please filter by an outstation first.', 'error');
      return;
    }
    
    const selectedStationName = this.filteredStations[0].name;
    const matchingStation = this.stationData.find(s => 
      s.outstationName?.toLowerCase() === selectedStationName?.toLowerCase()
    );
    
    if (!matchingStation?.id) {
      this.showSnackbar('Station not found. Please try again.', 'error');
      return;
    }

    this.isLoading = true;
    this.subscription = this.accountService
      .downloadReportPDF(matchingStation.id)
      .subscribe({
        next: (blob: Blob) => {
          // `blob` is itself the file – no `.data`
          const url = window.URL.createObjectURL(blob);
          window.open(url);
          this.isLoading = false;

          Swal.fire({
            icon: 'success',
            title: 'Members Report',
            text: 'Members Report Successfully Downloaded',
            confirmButtonText: 'OK'
          });
        },
        error: (err) => {
          console.error(err);
          this.errorMessage = err;    // store if you need
          this.isLoading = false;

          Swal.fire({
            icon: 'error',
            title: 'Members Report',
            text: 'Members Report Failed to Download',
            confirmButtonText: 'OK'
          });
        }
      });
  }

  navigateToFamilyMembers(id: any) {
    this.router.navigate(['/admin/reports/view-report'], {
      queryParams: { tab: 'family-per-community', id }
    });
  }

  navigateToMembers(id: any) {
    this.router.navigate(['/admin/reports/view-report'], {
      queryParams: { tab: 'members-by-outstation', id }
    });
  }

  navigateToCommunityMembers(id: any) {
    this.router.navigate(['/admin/reports/view-report'], {
      queryParams: { tab: 'groups-report', id }
    });
  }

  private showSnackbar(message: string, type: string) {
    this.snackbar.open(message, "Close", {
      duration: 5000,
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: `snackbar-${type}`
    });
  }
}
